export default __webpack_public_path__ + "static/media/gameplay_pig.c2b3b831.svg";